import React from 'react'

import Box from 'components_new/atoms/Box'

import { DataRerunSummary } from 'redux/selectors/internal/DataReruns'

export interface DataRerunProgressBarProps {
  rerun: DataRerunSummary
  sx?: object
}

/**
 * A thin bar of a rerun's customers: done, failed, skipped or cancelled and
 * running, the queued rest left as the track.
 */
const DataRerunProgressBar = (props: DataRerunProgressBarProps) => {
  const { rerun, sx } = props

  const total = Math.max(rerun.customer_count, 1)

  const segments = [
    { color: 'success.main', count: rerun.done_count },
    { color: 'error.main', count: rerun.failed_count },
    { color: 'grey.400', count: rerun.skipped_count + rerun.cancelled_count },
    { color: 'info.main', count: rerun.running_count }
  ].filter((segment) => segment.count > 0)

  return (
    <Box
      sx={{
        bgcolor: 'info.transparent',
        borderRadius: '3px',
        display: 'flex',
        height: 6,
        overflow: 'hidden',
        ...sx
      }}
    >
      {segments.map((segment) => (
        <Box
          key={segment.color}
          sx={{
            bgcolor: segment.color,
            width: `${(segment.count / total) * 100}%`
          }}
        />
      ))}
    </Box>
  )
}

DataRerunProgressBar.displayName = 'DataRerunProgressBar'
export default DataRerunProgressBar
